import {
  useLoaderData,
  useSearchParams,
  useNavigation,
} from 'react-router-dom';
import { ProviderSearchFiltersContext } from '@/common/contexts/ProviderSearchFiltersContext.tsx';
import { ProviderData } from '@/common/types';
import { Container } from 'react-bootstrap';

import ProviderSearch from '../../components/ProviderSearch.tsx';
import ProviderCard from '../../components/ProviderCard.tsx';
import PreSearchMessage from '@/website/routes/providers/components/PreSearchMessage.tsx';
import NoResultsFoundMessage from '@/website/routes/providers/components/NoResultsFoundMessage.tsx';

const ProvidersPage = () => {
  const [searchParams] = useSearchParams();
  const { providers } = useLoaderData() as {
    providers: ProviderData[];
  };
  const selectedState = searchParams.get('state_code');
  const selectedInsurance = searchParams.get('insurance_company_name');
  const navigation = useNavigation();

  const LoadingMessage = () => (
    <div className="text-center py-5">
      <div className="spinner-border text-primary mb-3" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="text-muted">Searching for providers...</p>
    </div>
  );

  return (
    <ProviderSearchFiltersContext.Provider
      value={{ selectedState, selectedInsurance }}
    >
      <>
        <section className="bg-white py-4">
          <Container>
            <ProviderSearch />
          </Container>
        </section>

        <section className="bg-light py-4">
          <Container>
            {navigation.state === 'loading' ? (
              <LoadingMessage />
            ) : (
              <>
                <PreSearchMessage
                  providers={providers}
                  selectedState={selectedState}
                  selectedInsurance={selectedInsurance}
                />
                <NoResultsFoundMessage
                  providers={providers}
                  selectedStateCode={selectedState}
                  selectedInsurance={selectedInsurance}
                />
                {providers.length > 0 &&
                  providers.map((provider) => (
                    <ProviderCard key={provider.id} provider={provider} />
                  ))}
              </>
            )}
          </Container>
        </section>
      </>
    </ProviderSearchFiltersContext.Provider>
  );
};

export default ProvidersPage;
